import { Box } from "@intech/web-ui";
import styled from "styled-components";

export const GrayBox = styled(Box)`
  color: #7c7e80;
`;